import { all } from "redux-saga/effects";
import { dataSagas } from "./dataSaga";
import { sessionSagas } from "./sessionSaga";

export default function* rootSaga() {
  yield all([...dataSagas, ...sessionSagas]);
}
